<template>
  <div class="page" :style="{'height': screenHeight}">

    <img class="bgimg" src="../../assets/images/loginleft.png" alt="" srcset="" />
    <van-cell-group>
      <van-field required v-model="form.name" type="" label="姓名" placeholder="请输入姓名" :label-width="80" />
      <van-field required v-model="form.company" type="" label="企业名称" placeholder="请输入企业名称" :label-width="80" />
      <van-field readonly @click="selectSF" required v-model="form.address" type="" label="选择省份" placeholder="请选择省份"
        :label-width="80" />
      <van-field required v-model="form.phone" type="" label="联系方式" placeholder="请输入联系方式" :label-width="80" />
      <van-field required v-model="form.email" type="" label="邮箱地址" placeholder="请输入邮箱地址" :label-width="80" />
      <van-field required v-model="form.content" type="textarea" label="留言内容" placeholder="请输入留言内容" :label-width="80" />
      <van-popup v-model="show" position="bottom" round data-popups="showArea" bind:close="hide_popup">
        <van-picker show-toolbar title="选择省份" :columns="columns" @cancel="onCancel" @confirm="onConfirm" />
      </van-popup>

    </van-cell-group>
    <div class="btn">
      <van-button @click="submit" type="info">提交</van-button>
    </div>

  </div>
</template>

<script>
  import jsonData from '@/utils/citylist.json'
  import {
    post
  } from '@/utils/request';
  export default {
    data() {
      return {
        password: '',
        columns: [],
        show: false,
        form: {
          name: '',
          company: '',
          phone: '',
          email: '',
          content: '',
          address: ''
        },
        screenHeight: ''
      }

    },
    created() {
      // this.screenHeight = uni.getSystemInfoSync().windowHeight + 'px';
      jsonData.map(item => {
        this.columns.push(item.name)
      })
    },
    methods: {
      validatePhoneNumber(phoneNumber) {
        // 定义手机号正则表达式
        const phoneRegex = /^1[34578]\d{9}$/;

        if (phoneRegex.test(phoneNumber)) {
          console.log('手机号格式正确');
          return true;
        } else {
          console.log('手机号格式错误');
          return false;
        }
      },
      validateEmail(email) {
         var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
         return re.test(email);
      },
      submit() {
        if (!this.form.name) {
          return this.$toast('请填写姓名');
        }
        if (!this.form.company) {
          return this.$toast('请填写企业名称');
        }
        if (!this.form.address) {
          return this.$toast('请选择省份');
        }
        if (!this.form.phone) {
          return this.$toast('请填写联系方式');
        }
        if(this.form.phone && !this.validatePhoneNumber(this.form.phone)) {
          return this.$toast('请填写正确联系方式');
        }
        if (!this.form.email) {
          return this.$toast('请填写邮箱地址');
        }
        if(this.form.email && !this.validateEmail(this.form.email)) {
          return this.$toast('请填写正确邮箱地址');
        }
        if (!this.form.content) {
          return this.$toast('请填写留言内容');
        }
        post('/api/website/trialApplication', this.form).then(res => {
          console.log(res)
          if(res.code == 1) {
            this.$toast(res.msg);
            this.form = {
              name: '',
              company: '',
              phone: '',
              email: '',
              content: '',
              address: ''
            }
          }else {
            this.$toast(res.msg);
          }

        })
      },
      onCancel() {
        this.show = false
      },
      onConfirm(e) {
        console.log(e)
        this.form.address = e
        this.show = false
      },
      selectSF() {
        console.log('123')
        this.show = true
      }
    }
  }
</script>

<style scoped>
  .page {
    position: relative;
    min-height: 100vh;
    /* background: url('../../assets/images/loginleft.png') top center no-repeat;
    background-size: 100% 100%; */
    display: flex;
    justify-content: center;
    align-items: center;
    background-attachment : fixed;
  }

  .bgimg {
    width: 100%;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }

  .van-cell-group {
    width: 100%;
    background-color: rgba(255, 255, 255, 0.5);
  }

  .van-cell {
    background-color: rgba(255, 255, 255, 0.8);
  }

  .btn {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .van-button {
    width: 90%;
  }

  .van-button--info {
    background: #062666 !important;
    border: 1px solid #062666;
  }
</style>



// WEBPACK FOOTER //
// src/views/market/MobileForm.vue